import { PayloadAction } from "@reduxjs/toolkit";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import {
  IErrorResponse,
  IPaginateApiResponse,
  IPermission,
  IUpdateRolePermissionRequest,
} from "model";
import { call, put, takeEvery } from "redux-saga/effects";
import { PermissionActions } from "redux/actions";
import PermissionApiService from "services/PermissionApiService";

function* updateRolePermissions(
  action: PayloadAction<IUpdateRolePermissionRequest>
) {
  try {
    const result: IPaginateApiResponse<IPermission[]> = yield call(
      PermissionApiService.updateRolePermission,
      action.payload
    );
    if (result.succeeded) {
      yield put(PermissionActions.updateRolePermissions.success(result.data!));
      AlertHelper.showAlert("Cập nhật quyền thành công", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(PermissionActions.updateRolePermissions.failed(error));
    }
  } catch (error) {
    yield put(PermissionActions.updateRolePermissions.failed(error));
  }
}

export function* Watcher() {
  yield takeEvery(
    PermissionActions.updateRolePermissions.request,
    updateRolePermissions
  );
}
